import storage from './localStorage';

const STORAGE_ITEM_KEY = 'user.settings';
const DOCUMENT_SIDEBAR_WIDTH = 'documentSidebarWidth';

export default {
  /**
   * @returns {Object}
   */
  getValues() {
    return storage.getObject(STORAGE_ITEM_KEY);
  },

  /**
   * @param {string} key
   * @param {*} value
   * @returns {void}
   */
  setValue(key, value) {
    let settings = this.getValues();
    settings[key] = value;
    storage.setItem(STORAGE_ITEM_KEY, settings);
  },

  /**
   * @returns {number|null}
   */
  getDocumentSidebarWidth() {
    let settings = this.getValues(),
      width = parseInt(settings[DOCUMENT_SIDEBAR_WIDTH]);

    return isNaN(width) ? null : width;
  },

  /**
   * @param {number} width
   * @returns {void}
   */
  setDocumentSidebarWidth(width) {
    this.setValue(DOCUMENT_SIDEBAR_WIDTH, width);
  }
};
